import { Component, Vue } from 'vue-property-decorator'
import VerifyPhoneDialogBody from '@/apps/open/components/DialogBodys/VerifyPhone.vue'
import { EVerifyPhoneAction } from '@/apps/open/types'

interface IVerifyProps {
  title?: string
  okBtn?: string
  action: EVerifyPhoneAction
  cb: Function
}

@Component
export default class VerifyPhoneMixin extends Vue {
  get userInfo () {
    return this.$store.getters['User/userInfo']
  }

  verifyPhone ({ title = '安全验证', action, okBtn = '下一步', cb }: IVerifyProps) {
    this.$dialog.show({
      title: title,
      width: '400px',
      body: VerifyPhoneDialogBody,
      bodyProps: {
        phone: this.userInfo.phone,
        action,
        okText: okBtn,
        onCancel: this.$dialog.close,
        verifySuccess: cb
      }
    })
  }
}
